const rowHasData = (row) => {
  return row.slice(1).some((x) => x);
};

export const chartHasData = (data) => {
  if (!data || data.length < 2) return false;
  const rows = data.slice(1);
  return rows.some(rowHasData);
};
